import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../firebase";

export const uploadFile = async (uri: RequestInfo | URL, path: string) => {
  try {
    const storageId = crypto.randomUUID();

    const fileRef = ref(storage, "images/" + path + "/" + storageId);

    const file = await fetch(uri);

    const bytes = await file.blob();

    await uploadBytes(fileRef, bytes);

    const storageUrl = await getDownloadURL(fileRef);

    return {
      storageUrl: storageUrl,
      storageId: storageId,
    };
  } catch (error: any) {
    console.error(error);
    return {
      success: false,
      message:
        "Uploading file failed with the following error code: " + error.code,
    };
  }
};
